// ═══════════════════════════════════════════════════════════════
// API: Comprobantes de pago por empleado (3 tipos)
// ═══════════════════════════════════════════════════════════════

import api from './config';

// ── Listar comprobantes ──────────────────────────────────────

/** Nóminas regulares cerradas del empleado */
export const getNominaReceipts = (employeeId) =>
  api.get(`/payroll/employee/${employeeId}/receipts-list`)
    .then(r => r.data.records || []);

/** Bonificaciones pagadas del empleado */
export const getBonificacionReceipts = (employeeId) =>
  api.get(`/bonificaciones/employee/${employeeId}/receipts`)
    .then(r => r.data.records || []);

/** Regalías pascuales pagadas del empleado */
export const getRegaliaReceipts = (employeeId) =>
  api.get(`/regalia-pascual/employee/${employeeId}/receipts`)
    .then(r => r.data.records || []);

// ── Descargar PDF como blob (para preview en iframe) ─────────

export const getNominaPayslipBlob = (payrollId, employeeId) =>
  api.get(`/payroll/${payrollId}/employee/${employeeId}/payslip`, { responseType: 'blob' })
    .then(r => r.data);

export const getBonificacionPayslipBlob = (bonificacionId, detalleId) =>
  api.get(`/bonificaciones/${bonificacionId}/detalle/${detalleId}/payslip`, { responseType: 'blob' })
    .then(r => r.data);

export const getRegaliaPayslipBlob = (regaliaId, recordId) =>
  api.get(`/regalia-pascual/${regaliaId}/records/${recordId}/payslip`, { responseType: 'blob' })
    .then(r => r.data);
